import { Error } from '@mui/icons-material';
import { Grid, Tooltip } from '@mui/material';
import './styles/ErrorMarker.scss';

interface Props {
  message: string;
}
export default function ErrorMarker(props: Props) {
  return (
    <Grid item xs="auto" className="error-marker">
      <Tooltip
        title={props.message}
        placement="left"
        classes={{ tooltip: 'error-marker__tooltip' }}
        enterDelay={0}
      >
        <Error className="error-marker__icon" />
      </Tooltip>
    </Grid>
  );
}
